import PurchasePricesHeader from './PurchasePricesHeader';

export default PurchasePricesHeader;
